import { render, staticRenderFns } from "./EditLessonAccessModal.vue?vue&type=template&id=7ca80e6f&lang=pug&"
import script from "./EditLessonAccessModal.vue?vue&type=script&lang=js&"
export * from "./EditLessonAccessModal.vue?vue&type=script&lang=js&"
import style0 from "./EditLessonAccessModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports